import * as React from "react";
import { Dictionary } from "../../../../core/types/Dictionary";
import { SET_TYPE_LOOKUP } from "../../../../lookup/Consts";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { hideModal, showModal, showUpdateFieldsModal } from "../../../../redux/reducers/ModalReducer";
import { addTab, clearModalSearchResults, setEditableFields, updateContributorSetType } from "../../../../redux/reducers/RepertoireReducer";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IWorkStateKeys } from "../../../../redux/types/IWorkState";
import CarouselScrollButton from "../../../components/carouselScrollButton/CarouselScrollButton";
import DataGridTable from "../../../components/dataGridTable/DataGridTable";
import { SizedDropdownDataInput } from "../../../components/dropdownDataInput/DropdownDataInput";
import { MessageBanner, MessageType } from "../../../components/messageBanner/MessageBanner";
import { IShowFieldSettingViewModalProps } from "../../../components/repertoireModal/RepertoireModal";
import { getDataAction } from "../../../components/toolBar/ToolbarHelper";
import {
    ADD_NEW_ACTION, AGREEMENT_MAINTENANCE_TOOLBAR, CONTRIBUTORS_DATA_VIEW_BREAK_INHERITANCE, CONTRIBUTORS_DATA_VIEW_CANNOT_SET_INHERITANCE_MESSAGE, CONTRIBUTORS_DATA_VIEW_DO_NOT_INHERIT, CONTRIBUTORS_DATA_VIEW_ICED, CONTRIBUTORS_DATA_VIEW_INHERITANCE_ADDED_MESSAGE, CONTRIBUTORS_DATA_VIEW_INHERITANCE_BROKEN_MESSAGE, CONTRIBUTORS_DATA_VIEW_INHERIT_FROM, CONTRIBUTORS_KEY, DATA_GRID_TABLE, DEPENDENT_ROW_ACTION, EDITABLE_FIELDS, EDITABLE_FIELDS_GRID, ICE_NUMBER_TYPE_CODE, OTHER_KEY, PLAIN_TEXT, SCREEN_WIDTH_CHANGE, SET_TYPE_KEY, TEXT_INPUT, TITLE_EDITABLE_FIELDS_VIEW, WORK_CONTRIBUTOR_RELATIONS_REQUIRED_MESSAGE, WORK_OTHERCONTRIBUTOR_SOURCEIP_STATE_KEY,
    WORK_OTHERCONTRIBUTOR_SOURCESOCIETY_STATE_KEY, WORK_OTHERCONTRIBUTOR_SOURCETYPE_STATE_KEY
} from "../../../Consts";
import { DataSource } from "../../../types/DataSource";
import { IAgreementLink } from "../../../types/IAgreementLink";
import { IAgreementShareDisplayConfiguration } from "../../../types/IAgreementShareDisplayConfiguration";
import { IContributorDataFilter } from "../../../types/IContributorDataFilter";
import { IContributorItem } from "../../../types/IContributorItem";
import { IDataActionToolbar } from "../../../types/IDataActionToolbar";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { isTableAction, ITableAction } from "../../../types/ITableAction";
import { IWorkContributorSetType } from "../../../types/IWorkContributorSetType";
import ContributorsDataViewButton from "../contributorsDataViewButton/ContributorsDataViewButton";
import ActionButton from "../../../components/actionButton/ActionButton";
import { IContributorTypes } from "../../../types/IContributorTypes";
import { sum } from "lodash";

export interface IContributorsDataViewProps {
    updateWorkField: (value: any, fieldName: IWorkStateKeys, index?: number) => void;
    showModal: typeof showModal;
    clearModalSearchResults: typeof clearModalSearchResults;
    addTab: typeof addTab;
    updateContributorSetType: typeof updateContributorSetType;
    tableContents: Dictionary<IContributorItem[]>;
    contributorsDataViewData?: IRepertoireComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    sortData: (value: any, name: IRepertoireStateKeys) => void;
    lookupValues: ILookupDictionary;
    tableActions?: ITableAction[];
    setTypeGroup: string;
    dataSource: DataSource;
    getAgreementDetails: (dataSource: string, agreementID: number, lookups: ILookupDictionary, dataAction?: IDataActionToolbar[], agreementGeneralDataView?: IRepertoireComponentDataItem) => void;
    workContributorSetTypes: IWorkContributorSetType[];
    contributorInheritanceChanged: boolean;
    isReadonly: boolean;
    resetMessageBanner: () => void;
    openInNewTab(openItem: any): void;
    tabs?: ITabReduxItem[];
    activeTab?: number;
    paneIndex?: number;
    currentUser?: string;
    contributorConfiguration?: string;
    agreementMaintenanceGeneralDataView: IRepertoireComponentDataItem;
    updateSetTypeOnBreak: (setType: string) => void;
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    editableFields: IRepertoireField[];
    editableContributorFieldGridDataView: IRepertoireComponentDataItem;
    contributorGridEditableFields: IRepertoireField[];
    setEditableFields: typeof setEditableFields;
    updateContributorFields?: (fields: IRepertoireField[], componentName: string, componentInstance?: string) => void;
    hideModal?: typeof hideModal;
    agreementShareDisplayOptions?: IAgreementShareDisplayConfiguration;
    shareDecimalsToDisplay?: number;
    updateComponentFieldsItems: (fields: IRepertoireField[],
        componentName: string,
        componentInstance: string,
        componentDataFieldName: string,
        tabs: ITabReduxItem[],
        activeTab: number) => void;
    addNewAccount: () => void;
    incrementTempID?: () => void;
    showContributorTabsAsDropdown?: boolean;
    loadWorkIceDistCacheAdditionalInfo: (workID: number, activeTabItem: ITabReduxItem, paneIndex: number) => void;
    defaultContributorsTabToOpen: string;
    isFromUsage?:boolean;
    enableDefaultMechShareUI?: boolean;
    contributorTypes: IContributorTypes;
    contributorRelationsRequiredWarning?: boolean;
    setContributorRelationsRequiredWarning?: (contributorRelationsRequiredWarning: boolean) => void;
}

const REPERTOIRE = "repertoire";
const DISTRIBUTIONS = "distribution";

const ContributorsDataView: React.FC<IContributorsDataViewProps> = ({
    loadWorkIceDistCacheAdditionalInfo,
    tabs,
    activeTab,
    paneIndex,
    contributorsDataViewData,
    workContributorSetTypes,
    tableContents,
    updateWorkField,
    isFromUsage,
    setTypeGroup,
    isReadonly,
    setContributorRelationsRequiredWarning,
    contributorTypes,
    updateSetTypeOnBreak,
    updateContributorSetType,
    dataSource,
    contributorInheritanceChanged,
    resetMessageBanner,
    contributorRelationsRequiredWarning,
    lookupValues,
    showUpdateFieldsModal,
    editableContributorFieldGridDataView,
    dataGridTableData,
    setEditableFields,
    updateComponentFieldsItems,
    editableFields,
    sortData,
    showModal,
    clearModalSearchResults,
    addTab,
    openInNewTab,
    currentUser,
    contributorConfiguration,
    agreementShareDisplayOptions,
    shareDecimalsToDisplay,
    addNewAccount,
    incrementTempID,
    showContributorTabsAsDropdown,
    enableDefaultMechShareUI,
    agreementMaintenanceGeneralDataView,
    getAgreementDetails
}) => {
    const viewData = React.useRef<Record<string, any>>({});
    const iceDistFetchAttemptedByWork = React.useRef<Record<number, boolean>>({});
    const currentWorkID = tabs?.[activeTab]?.workMaintenanceState?.work?.workID;
    const [activeSetType, setActiveSetType] = React.useState<string>(
        () => getInitialTabToOpen()
    );

    const [loaded, setLoaded] = React.useState(false);
    const [otherSourceType, setOtherSourceType] = React.useState("All");
    const [otherSourceIp, setOtherSourceIp] = React.useState("All");
    const [otherSourceSociety, setOtherSourceSociety] = React.useState("All");

    function getInitialTabToOpen() {
        return iceNumberExistsInWork() ? CONTRIBUTORS_DATA_VIEW_ICED : REPERTOIRE;
    }

      React.useEffect(() => {
        const fields = contributorsDataViewData?.fields ?? [];

        fields.forEach(item => {
            viewData.current[item.name] = item.data;
        });

        if (fields.length > 0) {
            setLoaded(true);
        }

        if (
            workContributorSetTypes &&
            tableContents &&
            activeSetType &&
            isFromUsage
        ) {
            const tableContentsCopy: Dictionary<IContributorItem[]> =
                JSON.parse(JSON.stringify(tableContents));

            workContributorSetTypes
                .filter(s => s.inheritFromSetType === activeSetType)
                .forEach(setType => {
                    const contributors: IContributorItem[] =
                        JSON.parse(
                            JSON.stringify(
                                tableContentsCopy[activeSetType]
                            )
                        );

                    tableContentsCopy[setType.setType] = contributors;

                    Object.keys(tableContentsCopy).forEach(key => {
                        tableContentsCopy[key]?.forEach(x => {
                            if (
                                x.mechanicalShareToDisplay &&
                                x.mechPercentage
                            ) {
                                x.mechanicalShareToDisplay.value =
                                    x.mechPercentage.value.toString();
                            }

                            if (
                                x.performingShareToDisplay &&
                                x.perfPercentage
                            ) {
                                x.performingShareToDisplay.value =
                                    x.perfPercentage.value.toString();
                            }
                        });
                    });

                    updateWorkField(
                        tableContentsCopy,
                        CONTRIBUTORS_KEY
                    );
                });
        }
    }, []);

        React.useEffect(() => {
            if (activeSetType === CONTRIBUTORS_DATA_VIEW_ICED) {
                onLoadWorkIceDistCacheAdditionalInfo(CONTRIBUTORS_DATA_VIEW_ICED);
            }
        }, [activeSetType, currentWorkID, activeTab, paneIndex]);

        function onLoadWorkIceDistCacheAdditionalInfo(activeSetType: IRepertoireStateKeys) {
            if(activeSetType !== CONTRIBUTORS_DATA_VIEW_ICED){
                return;
            }

            const activeTabItem = tabs && tabs[activeTab];
            const workID = activeTabItem?.workMaintenanceState?.work?.workID;

            if (!activeTabItem || workID == null || activeTabItem.iceDistCacheAdditionalInfoState || iceDistFetchAttemptedByWork.current[workID]) {
                return;
            }

            iceDistFetchAttemptedByWork.current[workID] = true;
            loadWorkIceDistCacheAdditionalInfo(workID, activeTabItem, paneIndex);
        }

        function iceNumberExistsInWork() {
            const numbers = tabs && tabs[activeTab] && tabs[activeTab].workMaintenanceState?.work?.numbers;
            return numbers ? numbers.some( x => x.type.value === ICE_NUMBER_TYPE_CODE) : false;
        }

        const setButtonActive = (name: IRepertoireStateKeys) => {
            setActiveSetType(name); 
        };

        const handleSelect = event => {
            let value = event.target.value;
            setButtonActive(value);
        };

        const renderTabs = () => {
            return contributorsDataViewData.fields.filter(f => f.fieldType === SET_TYPE_KEY && f.hidden === false).map((field, index) => (
                <ContributorsDataViewButton key={index}
                    text={field.data}
                    active={field.name === activeSetType}
                    onClick={() => setButtonActive(field.name)}
                />
            ));
        };


        const filterTableContents = () => {
            let filteredTableContents: IContributorItem[] = [];

            if (activeSetType === OTHER_KEY) {
                const setTypeTabs: string[] = [] //
                contributorsDataViewData.fields
                    .filter(f => f.fieldType === SET_TYPE_KEY)
                    .filter(f => f.name !== OTHER_KEY)
                    .map(f => setTypeTabs.push(f.name));
            }

            if (activeSetType === OTHER_KEY) {

                if (tableContents[activeSetType] !== undefined) {
                    let flitered = tableContents[activeSetType].filter(f => f.setTypeGroup === setTypeGroup)

                    if (otherSourceIp != null && otherSourceIp !== "" && otherSourceIp != "All") {
                        flitered = flitered.filter(f => (f.sourceIP != null ? f.sourceIP.toString() === otherSourceIp : false));
                    }

                    if (otherSourceSociety != null && otherSourceSociety !== "" && otherSourceSociety != "All") {
                        flitered = flitered.filter(f => f.sourceSociety === otherSourceSociety);
                    }

                    if (otherSourceType != null && otherSourceType !== "" && otherSourceType != "All") {
                        flitered = flitered.filter(f => f.sourceType == otherSourceType);
                    }

                    filteredTableContents = JSON.parse(
                        JSON.stringify(flitered.filter(f => f.setTypeGroup === setTypeGroup))
                    );
                }

            }
            else if (tableContents[activeSetType]) {
                filteredTableContents = JSON.parse(
                    JSON.stringify(tableContents[activeSetType].filter(f => f.setTypeGroup === setTypeGroup))
                );
            } else if(tableContents[activeSetType] === undefined && activeSetType === DISTRIBUTIONS && tableContents[REPERTOIRE] && workContributorSetTypes.find(w => w.setType === DISTRIBUTIONS)['inheritFromSetType'] === REPERTOIRE) {
                filteredTableContents = JSON.parse(
                    JSON.stringify(tableContents[REPERTOIRE].filter(f => f.setTypeGroup === setTypeGroup))
                );
            }

            return filteredTableContents;
        };

        const renderDropdown = () => {
            return (
                <select className="dropdown" onChange={handleSelect}>
                    {contributorsDataViewData.fields.filter(f => f.fieldType === SET_TYPE_KEY).map((field, index) => (
                        <option key={index} value={field.name}>
                            {field.data}
                        </option>
                    ))}
                </select>
            );
        };


        const changeDataLocal = (value: IContributorItem[], name: IRepertoireStateKeys) => {
            if (isReadonly)
                return;

            const tableContentsCopy: Dictionary<IContributorItem[]> = JSON.parse(JSON.stringify(tableContents));
            const distributionContentCopy: IContributorItem[] = tableContents["distribution"] ? tableContents["distribution"] : [];


            let exisitingData: IContributorDataFilter[] = [];

            distributionContentCopy.forEach(x => {
                exisitingData.push({
                    setTypeGroup: x.setTypeGroup,
                    ipBaseNumber: x.ipBaseNumber,
                    ipiNumber: x.ipiNumber.value,
                    mechSocietyAffiliation: x.mechSocietyAffiliation.value,
                    perfSocietyAffiliation: x.perfSocietyAffiliation.value,
                    relationships: x.relationships
                });
            });

            const otherSetTypeGroups: IContributorItem[] = tableContentsCopy[activeSetType] ?
                tableContentsCopy[activeSetType].filter(c => c.setTypeGroup !== setTypeGroup && c.setType == activeSetType)
                : [];
            tableContentsCopy[activeSetType] = [...value, ...otherSetTypeGroups];

            workContributorSetTypes.filter(s => s.inheritFromSetType === activeSetType).map((setType, i) => {
                const contributors: IContributorItem[] = JSON.parse(JSON.stringify(tableContentsCopy[activeSetType]));
                contributors.forEach((c: IContributorItem, index: number) => {
                    const data: IContributorDataFilter = exisitingData.find(x => x.setTypeGroup === c.setTypeGroup && x.ipBaseNumber === c.ipBaseNumber && x.ipiNumber === c.ipiNumber.value);
                    if (data) {
                        c.mechSocietyAffiliation = { value: data.mechSocietyAffiliation, inputType: PLAIN_TEXT };
                        c.perfSocietyAffiliation = { value: data.perfSocietyAffiliation, inputType: PLAIN_TEXT };
                    }
                    c.setType = setType.setType;
                    c.workContributorID = - Math.abs(c.workContributorID) * (i + 1);
                    c.agreementChain = []
                });
                tableContentsCopy[setType.setType] = contributors;
            });

            Object.keys(tableContentsCopy).forEach(key => {
                if (tableContentsCopy[key] && tableContentsCopy[key].length > 0) {
                    tableContentsCopy[key].forEach(x => {
                        if (x.mechanicalShareToDisplay?.value != null && x.mechPercentage?.value != null)
                            x.mechanicalShareToDisplay.value = x.mechPercentage.value.toString();
                        if (x.performingShareToDisplay?.value != null && x.perfPercentage?.value != null)
                            x.performingShareToDisplay.value = x.perfPercentage.value.toString();
                    });
                }
            })

            updateWorkField(tableContentsCopy, CONTRIBUTORS_KEY);
        }

        const updateContributorRelationships = (value: string, contributors: IContributorItem[], rowIndex: number): void => {
            const contributor = contributors[rowIndex];
            contributor.relationships = value;
            contributor.relationshipIDs = [];

            const str = !!value ? value.trim() : '';
            // if the string is empty, remove all relationships from this contributor to others 
            // and from other contributors to this one
            if (str == '') {
                contributor.relationshipIDs = [];
                contributor.isEditingRelationships = false;

                for (let i = 0; i < contributors.length; i++) {
                    if (contributors[i].relationshipIDs) {
                        const k = contributors[i].relationshipIDs.indexOf(contributor.workContributorID); // if contributor has relationship
                        if (k > -1) {
                            contributors[i].relationshipIDs.splice(k, 1); // remove the relationship
                        }
                    }
                }
            }
            else if (str.endsWith(';')) {
                contributor.isEditingRelationships = false;
                const relsTo = str.split(';').filter(r => r.startsWith('T'));

                // add relationships to other contributors
                relsTo.map(r => {
                    let index: number = parseInt(r.trim().substring(1))
                    if (!isNaN(index)) {
                        const contributorIndex: number = index - 1;
                        if (
                            contributorIndex >= 0
                            && contributorIndex <= contributors.length - 1 // index is within array bounds
                            && contributorIndex !== rowIndex) { // does not refer to the contributor getting edited

                            const id: number = contributors[contributorIndex].workContributorID;
                            if (!contributor.relationshipIDs.find(x => x === id)) {
                                contributor.relationshipIDs.push(id);
                            }
                        }
                    }
                });

                // get all relationships from other contributors to this one.
                // remove them if they don't have a corresponding F relationship here.
                const relsFrom = str.split(';').filter(r => r.startsWith('F')); // remove rel from if it has been deleted
                const indexesOfContributorsWithRelations: number[] = [];
                relsFrom.map(r => {
                    let index: number = parseInt(r.trim().substring(1))
                    if (!isNaN(index)) {
                        const contributorIndex: number = index - 1;
                        if (
                            contributorIndex >= 0
                            && contributorIndex <= contributors.length - 1 // index is within array bounds
                            && contributorIndex !== rowIndex) { // does not refer to the contributor getting edited
                            indexesOfContributorsWithRelations.push(contributorIndex);
                        }
                    }
                });
                for (let i = 0; i < contributors.length; i++) {
                    if (contributors[i].relationshipIDs) {
                        let k = contributors[i].relationshipIDs.indexOf(contributor.workContributorID); // if contributor has relationship
                        if (k === -1) {
                            k = contributors[i].relationshipIDs.indexOf(-contributor.workContributorID);
                        }
                        if (k > -1 && !str.includes('F' + (i + 1) + ';')) {
                            contributors[i].relationshipIDs.splice(k, 1); // remove the relationship
                        }
                    }

                }
            }
            else {
                contributor.isEditingRelationships = true; // suppress recalculating while the user is enter text. Wait for ';'
            }
            changeDataLocal(contributors, CONTRIBUTORS_KEY);
        }

        const calculateContributorRelationships = (contributors: IContributorItem[]) => {
            if (contributors) {
                contributors.map(c => {
                    if (!c.isEditingRelationships) { // suppress recalculating while the user is enter text. Wait for ';'
                        let relationships: string = '';
                        if (c.relationshipIDs) {
                            c.relationshipIDs.map(r => {
                                const index: number = contributors.findIndex(c => Math.abs(c.workContributorID) === Math.abs(r));
                                if (index !== -1) {
                                    relationships = relationships + 'T' + (index + 1) + ';'
                                }
                            });
                        }
                        c.relationships = relationships;
                    }
                });
                contributors.map(c => {
                    if (!c.isEditingRelationships) {
                        const otherContributors = contributors.filter(oc => Math.abs(oc.workContributorID) !== Math.abs(c.workContributorID));
                        otherContributors.map(oc => {
                            if (oc.relationshipIDs && oc.relationshipIDs.findIndex(x => Math.abs(x) == Math.abs(c.workContributorID)) > -1) {
                                c.relationships = c.relationships + 'F' + (contributors.findIndex(x => Math.abs(x.workContributorID) == Math.abs(oc.workContributorID)) + 1) + ';'
                            }
                        })
                    }
                });
            }
        }

        const defaultMechShares = (): void => {
            const tableContentsCopy: Dictionary<IContributorItem[]> = JSON.parse(JSON.stringify(tableContents));
            const contributors = tableContentsCopy[activeSetType];

            setContributorRelationsRequiredWarning(false);

            const mechShares: Dictionary<number> = contributors.reduce((acc, contributor) => {
                acc[contributor.workContributorID] = 0;
                return acc;
            }, {});

            for (const contributor of contributors) {
                const isPublisher = contributorTypes.publisherTypes.includes(contributor.role.value);
                const isWriter = contributorTypes.writerTypes.includes(contributor.role.value);
                const relationshipsTo = contributors.filter(c => contributor.relationshipIDs?.includes(c.workContributorID));
                const relationshipsFrom = contributors.filter(c => c.relationshipIDs?.includes(contributor.workContributorID));

                if (isPublisher && relationshipsFrom.length === 0) {
                    setContributorRelationsRequiredWarning(true);
                    return;
                }

                if (isWriter && contributor.mechPercentage.value == 0) {
                    if (relationshipsTo.length === 0) {
                        mechShares[contributor.workContributorID] = contributor.perfPercentage.value;
                    } 
                    else if (relationshipsTo.length === 1) {
                        mechShares[relationshipsTo[0].workContributorID] += contributor.perfPercentage.value;
                    } 
                    else if (sum(relationshipsTo.map(r => r.perfPercentage.value)) === contributor.perfPercentage.value) {
                        relationshipsTo.forEach(r => {
                            mechShares[r.workContributorID] += r.perfPercentage.value;
                        });
                    }
                }
            }

            contributors.forEach(contributor => {
                const isPublisher = contributorTypes.publisherTypes.includes(contributor.role.value);
                const mechShare = mechShares[contributor.workContributorID];
                
                contributor.mechPercentage.value ||= mechShare + (isPublisher && mechShare > 0 ? contributor.perfPercentage.value : 0);
                contributor.mechanicalShareToDisplay.value = contributor.mechPercentage.value.toString();
            });

            changeDataLocal(contributors, CONTRIBUTORS_KEY);
        }

        const getAgreementDetailsLocal = (agreementLink: IAgreementLink): void => {
            const actionList = getDataAction(dataSource, AGREEMENT_MAINTENANCE_TOOLBAR);
            getAgreementDetails(dataSource.toString(), agreementLink.agreementID, lookupValues, actionList, agreementMaintenanceGeneralDataView)
        }

        const toggleContributorInheritance = (option: string): void => {
            if (isReadonly)
                return;

            const copy: IWorkContributorSetType[] = JSON.parse(JSON.stringify(workContributorSetTypes));
            const current = copy.find(s => s.setType === activeSetType);
            if (current) {
                if (option === null || option === CONTRIBUTORS_DATA_VIEW_DO_NOT_INHERIT) {
                    current.inheritFromSetType = null;
                    updateSetTypeOnBreak(current.setType);
                }
                else {
                    current.inheritFromSetType = option as string;
                }

                updateContributorSetType(current.setType, current.inheritFromSetType);
            }
        }

        const isInherits = (): boolean => {
            const current = workContributorSetTypes.find(s => s.setType === activeSetType);
            const parentSetType = current && current.inheritFromSetType;
            return !!parentSetType;
        }

        const changeFilter = (value: any, name: IRepertoireStateKeys) => {

            if (name == WORK_OTHERCONTRIBUTOR_SOURCETYPE_STATE_KEY) {
                setOtherSourceType(value);
          
            }
            else if (name == WORK_OTHERCONTRIBUTOR_SOURCEIP_STATE_KEY) {
                setOtherSourceIp(value);
            }
            else if (name == WORK_OTHERCONTRIBUTOR_SOURCESOCIETY_STATE_KEY) {
                setOtherSourceSociety(value);
            }
        }

        const renderOtherFilters = () => {

            if (activeSetType !== OTHER_KEY)
                return null;

            let sourceType = null;
            let sourceIp = null;
            let sourceSociety = null;

            if (tableContents[activeSetType] != undefined) {
                sourceType = tableContents[activeSetType].filter(x => x.sourceType !== "" && x.sourceType !== null).map(x => ({ code: x.sourceType, description: x.sourceType })).filter((v, i, a) => a.findIndex(t => (t.code === v.code)) === i);
                sourceIp = tableContents[activeSetType].filter(x => x.sourceIP !== null).map(x => ({ code: x.sourceIP.toString(), description: x.sourceIP.toString() })).filter((v, i, a) => a.findIndex(t => (t.code === v.code)) === i);
                sourceSociety = tableContents[activeSetType].filter(x => x.sourceSociety !== "" && x.sourceSociety !== null).map(x => ({ code: x.sourceSociety, description: x.sourceSociety })).filter((v, i, a) => a.findIndex(t => (t.code === v.code)) === i);

                sourceType.unshift({ code: "All", description: "All" });
                sourceIp.unshift({ code: "All", description: "All" });
                sourceSociety.unshift({ code: "All", description: "All" });

            }


            return <div className="col-md-6 col-sm-12">
                <div className="otherContributorFilters">
                    <SizedDropdownDataInput
                        label={viewData.current[WORK_OTHERCONTRIBUTOR_SOURCETYPE_STATE_KEY]}
                        fieldName={WORK_OTHERCONTRIBUTOR_SOURCETYPE_STATE_KEY}
                        value={otherSourceType}
                        changeData={changeFilter}
                        options={sourceType}
                        allowNull={true}
                        readOnly={isReadonly}
                        isHidden={false}
                    />
                    <SizedDropdownDataInput
                        label={viewData.current[WORK_OTHERCONTRIBUTOR_SOURCEIP_STATE_KEY]}
                        fieldName={WORK_OTHERCONTRIBUTOR_SOURCEIP_STATE_KEY}
                        value={otherSourceIp}
                        changeData={changeFilter}
                        options={sourceIp}
                        allowNull={true}
                        readOnly={isReadonly}
                        isHidden={false}
                    />
                    <SizedDropdownDataInput
                        label={viewData.current[WORK_OTHERCONTRIBUTOR_SOURCESOCIETY_STATE_KEY]}
                        fieldName={WORK_OTHERCONTRIBUTOR_SOURCESOCIETY_STATE_KEY}
                        value={otherSourceSociety}
                        changeData={changeFilter}
                        options={sourceSociety}
                        allowNull={true}
                        readOnly={isReadonly}
                        isHidden={false}
                    />
                </div>
            </div>
        }

        const renderBanner = () => {
            if (!contributorInheritanceChanged && !contributorRelationsRequiredWarning)
                return null;
            else if (contributorInheritanceChanged && isInherits())
                return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Information} messages={[viewData.current[CONTRIBUTORS_DATA_VIEW_INHERITANCE_ADDED_MESSAGE]]} />;
            else if (contributorInheritanceChanged && !isInherits())
                return <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Information} messages={[viewData.current[CONTRIBUTORS_DATA_VIEW_INHERITANCE_BROKEN_MESSAGE]]} />;
            else if (contributorRelationsRequiredWarning) {
                return <MessageBanner resetMessageBanner={() => (setContributorRelationsRequiredWarning(false))} messageType={MessageType.Danger} messages={[viewData.current[WORK_CONTRIBUTOR_RELATIONS_REQUIRED_MESSAGE]]} />;
            }
        }

        const renderSetTypeInheritanceOptions = () => {
            const inherits = isInherits();
            if (activeSetType === OTHER_KEY)
                return null;
            const renderOptions = () => {
                var options: JSX.Element[] = [];
                options.push(<option key={-1} value={CONTRIBUTORS_DATA_VIEW_DO_NOT_INHERIT} title={viewData.current[CONTRIBUTORS_DATA_VIEW_DO_NOT_INHERIT]}>
                    {viewData.current[CONTRIBUTORS_DATA_VIEW_DO_NOT_INHERIT]}
                </option>)

                const filteredSetTypes = workContributorSetTypes.filter(s => s.inheritFromSetType === null && s.setType !== activeSetType);

                filteredSetTypes.map((setType, i) => {
                    const lookup = lookupValues[SET_TYPE_LOOKUP];
                    if (lookup) {
                        const description = lookupValues[SET_TYPE_LOOKUP].lookups.find(l => l.code === setType.setType).description;
                        options.push(<option key={i} value={setType.setType} title={description}>
                            {description}
                        </option>)
                    }
                })

                return options;
            }

            const value: string = inherits ? workContributorSetTypes.find(s => s.setType === activeSetType).inheritFromSetType : CONTRIBUTORS_DATA_VIEW_DO_NOT_INHERIT;
            const disabled: boolean = !!workContributorSetTypes.find(s => s.inheritFromSetType === activeSetType) || isReadonly;


            return <>
                <div className="form-group col-md-3 col-sm-6 col-xs-12 flexContent">
                    <label>{viewData.current[CONTRIBUTORS_DATA_VIEW_INHERIT_FROM]}</label>
                    <select
                        onChange={(event) => toggleContributorInheritance(event.target.value)}
                        value={value}
                        disabled={disabled}
                        title={disabled ? viewData.current[CONTRIBUTORS_DATA_VIEW_CANNOT_SET_INHERITANCE_MESSAGE] : null}
                    >
                        {renderOptions()}
                    </select>
                </div>
                {
                    inherits ?
                        <div className="form-group col-md-3 col-sm-6 col-xs-12 margin-topSmall flexContent">
                            <div className="verticalDivider"></div>
                            <div className="IconTextButton" onClick={(e) => toggleContributorInheritance(null)}>
                                <i className="icon ms-Icon ms-Icon--RemoveLink" aria-hidden={true}></i>
                                {viewData.current[CONTRIBUTORS_DATA_VIEW_BREAK_INHERITANCE]}
                            </div>
                        </div> : null
                }
            </>
        }

        const renderDefaultMechShares = () => {
            return <div className="form-group col-md-2 col-sm-6 col-xs-12">
                <ActionButton
                    buttonText={"Default Shares"}
                    buttonAction={defaultMechShares.bind(this)}
                    disabled={false}
                    className="button btn-defaultPrimary noMargin"
                />
            </div>
        }



        const showFieldsModal = () => {
            setEditableFields(DATA_GRID_TABLE, CONTRIBUTORS_KEY)

            const fieldsViewData: IRepertoireComponentDataItem = { fields: editableContributorFieldGridDataView.fields.filter(x => x.componentInstance === EDITABLE_FIELDS_GRID) };
            const title: string = fieldsViewData.fields.find(item => item.name === TITLE_EDITABLE_FIELDS_VIEW).data;

            const fieldSetting: IShowFieldSettingViewModalProps = {
                componentInstance: EDITABLE_FIELDS,
                componentViewData: fieldsViewData,
                dataGridViewData: dataGridTableData,
                onClickSave: () => onSaveEditableFields()
            }

            showUpdateFieldsModal(title, fieldSetting);
        }

        const onSaveEditableFields = () => {
            updateComponentFieldsItems(editableFields["default"], DATA_GRID_TABLE, CONTRIBUTORS_KEY, DATA_GRID_TABLE, tabs, activeTab);
        }


        const renderTable = () => {

            const inherits: boolean = isInherits();
            const tableActions: ITableAction[] = [{ name: ADD_NEW_ACTION, disabled: inherits }];

            dataGridTableData.fields.forEach(f => f.disabled = null);
            if (inherits) {
                dataGridTableData.fields.forEach(f => {
                    if (isTableAction(f.fieldType) && f.fieldType !== DEPENDENT_ROW_ACTION)
                        f.disabled = true;
                })
            }
            

            const filteredContributors = activeSetType === CONTRIBUTORS_DATA_VIEW_ICED ? 
                tabs[activeTab].iceDistCacheAdditionalInfoState?.workContributors : filterTableContents();
            calculateContributorRelationships(filteredContributors);

            return (
                <>
                    <div className="contributorsDataView">
                        <DataGridTable
                            tableContents={filteredContributors}
                            tableActions={tableActions}
                            stateKey={CONTRIBUTORS_KEY}
                            dataGridTableData={dataGridTableData}
                            componentInstance={CONTRIBUTORS_KEY}
                            changeData={changeDataLocal}
                            sortData={sortData}
                            showModal={showModal}
                            clearModalSearchResults={clearModalSearchResults}
                            lookupValues={lookupValues}
                            addTab={addTab}
                            showDropdownsAsCodes={true}
                            showRowNumber={true}
                            setTypeGroup={setTypeGroup}
                            activeSetType={activeSetType}
                            dataSource={dataSource}
                            dependentRowAction={getAgreementDetailsLocal}
                            isReadOnly={inherits || isReadonly}
                            openInNewTab={openInNewTab}
                            tabs={tabs}
                            activeTab={activeTab}
                            currentUser={currentUser}
                            contributorConfiguration={contributorConfiguration}
                            updateContributorRelationships={updateContributorRelationships}
                            showFieldsModal={showFieldsModal}
                            agreementShareDisplayOptions={agreementShareDisplayOptions}
                            shareDecimalsToDisplay={shareDecimalsToDisplay}
                            addNewAccount={addNewAccount}
                            incrementTempID={incrementTempID}
                        />
                    </div>
                </>
            );
        };


            if (!loaded &&  contributorsDataViewData?.fields?.length < 0)
                return null;

            return (
                <div className="buttonsCarouselView">
                    <div className="form-group col-md-6 col-sm-6 col-xs-12 flexContent">
                        <CarouselScrollButton
                            content={showContributorTabsAsDropdown ? renderDropdown() : renderTabs()}
                            distanceToScroll={100}
                        />
                    </div>
                    {renderSetTypeInheritanceOptions()}
                    {renderOtherFilters()}
                    {enableDefaultMechShareUI && renderDefaultMechShares()}
                    <div className="form-group col-md-1 col-sm-6 col-xs-12 flex-end-Content">
                        <button className="contributorGearBtn" title="Configure data fields" onClick={showFieldsModal}>
                            <i className="ms-Icon ms-Icon--Settings"></i>
                        </button>
                    </div>
                    {renderBanner()}
                    {renderTable()}
                </div>
            );
    }

export default ContributorsDataView;
    
